export default "__VITE_ASSET__leK8QoHz__"